module.exports = __webpack_public_path__ + "static/img/tab4.9f867ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/tab4.jpg
// module id = 3144
// module chunks = 1